export function getEmailValidationError(emailRaw?: string | null): string | null {
	const email = emailRaw?.trim();
	if (!email) {
		return "E-postadresse mangler";
	}
	if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email)) {
		return 'E-postadresse må være på rett format, f.eks. "kari.nordmann@nte.no"';
	}
	return null;
}
